(function (window, document, undefined) {



  // inView

  const throttle = (fn, threshhold = 100, scope) => {
    let last, deferTimer;
    return () => {
      const context = scope || this,
            now = +(new Date()),
            args = arguments;
      if (last && now < last + threshhold) {
        clearTimeout(deferTimer)
        deferTimer = setTimeout(() => {
          last = now;
          fn.apply(context, args);
        }, threshhold);
      } else {
        last = now;
        fn.apply(context, args);
      }
    }
  }
  
  const hasClass = (el, name) => new RegExp(' ' + name + ' ').test(' ' + el.className + ' ');
  
  const addClass = (el, name) => {
    if (!hasClass(el, name)) {
      el.className += ' ' + name;
    }
    return el;
  }
  
  const removeClass = (el, name) => {
    const newClass = ' ' + el.className.replace(/[\t\r\n]/g, ' ') + ' ';
    if (hasClass(el, name)) {
      while (newClass.indexOf(' ' + name + ' ') >= 0) {
        newClass = newClass.replace(' ' + name + ' ', ' ');
      }
      el.className = newClass.replace(/^\s+|\s+$/g, '');
    }
    return el;
  }
  
  const removeEvent = (el, name, fn) => {
    if (el.removeEventListener) {
      return el.removeEventListener(name, fn);
    } else if (el.detachEvent) {
      return el.detachEvent('on' + name, fn);
    }
  }
  
  const addEvent = (el, name, fn) => {
    if (el.addEventListener) {
      return el.addEventListener(name, fn, false);
    } else if (el.attachEvent) {
      return el.attachEvent('on' + name, fn);
    }
  }
  
  const getScrollTop = () => {
    if (typeof window.pageYOffset !== 'undefined') {
      return window.pageYOffset;
    } else {
      const b = document.body,
            d = document.documentElement;
      d = d.clientHeight ? d : b;
      return d.scrollTop;
    }
  }
  
  const isInView = obj => {
    const winTop = getScrollTop(),
          winBottom = winTop + window.innerHeight,
          objTop = obj.getBoundingClientRect().top + window.scrollY,
          objBottom = objTop + obj.offsetHeight,
          offset = 0;
    return objTop <= winBottom + offset && objBottom >= winTop;
  }

  function InView (el, callback) {
    let _this = {};
    _this.el = el;
    _this.callback = callback.bind(_this);
    _this.destroy = () => {};
  
    if (!el) {
      return _this;
    }
  
    let isDestroyed = false;
  
    const check = (e) => {
      if (isDestroyed) return false;
  
      const params = {
        windowScrollTop:  getScrollTop(),
        elementOffsetTop: _this.el.offsetTop,
        inViewHeight:     window.innerHeight,
        elementOffsetTopInViewHeight:
          window.innerHeight -
          (getScrollTop() - (_this.el.offsetTop - window.innerHeight)),
      };
      if (isInView(_this.el)) {
        addClass(_this.el, "inview");
        _this.callback.call(_this, true, params);
      } else {
        removeClass(_this.el, "inview");
        _this.callback.call(_this, false, params);
      }
    };
  
    const throttledCheck = throttle(check, 100);
  
    addEvent(window, "scroll", throttledCheck);
  
    _this.destroy = () => {
      isDestroyed = true;
      removeEvent(window, "scroll", throttledCheck);
    };
  
    throttledCheck();
  
    return _this;
  };
  


  // Basic accordion animations 

  window.animationSlideUp = (target, duration = 600, parent_or_link) => {
    if (!target.classList.contains('animation_start')) {
      if (parent_or_link){
        parent_or_link.classList.remove('is_active_start');
        parent_or_link.classList.remove('animation_end');
      }
      target.classList.remove('animation_end');
      target.classList.add('animation_start');
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.boxSizing = 'border-box';
      target.style.height = target.offsetHeight + 'px';
      target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      
      if (window.animation_timeout) {
        clearTimeout(window.animation_timeout);
      }

      window.animation_timeout = setTimeout( () => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        target.classList.remove('animation_start');
        target.classList.remove('animation_end');
        if (parent_or_link){
          parent_or_link.classList.remove('is_active_end');
          parent_or_link.classList.remove('animation_end');
        }
      }, duration);
    }
  }

  window.animationSlideDown = (target, duration = 600, parent_or_link) => {
    if (!target.classList.contains('animation_start')) {
      if (parent_or_link){
        parent_or_link.classList.add('is_active_start');
        parent_or_link.classList.remove('animation_end');
      }
      target.classList.remove('animation_end');
      target.classList.add('animation_start');
      let display = window.getComputedStyle(target).display;
      target.style.removeProperty('display');

      if (display === 'none') {
        display = 'block';
        target.style.display = display;
        let height = target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
      }
      
      if (window.animation_timeout) {
        clearTimeout(window.animation_timeout);
      }

      window.animation_timeout = setTimeout( () => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        target.classList.remove('animation_start');
        target.classList.add('animation_end');
        if (parent_or_link){
          parent_or_link.classList.add('is_active_end');
          parent_or_link.classList.remove('animation_end');
        }
      }, duration);
    }
  }

  window.animationSlideToggle = (target, duration = 600, parent_or_link) => {
    if (window.getComputedStyle(target).display === 'none') {
      window.animationSlideDown(target, duration, parent_or_link);
    } else {
      window.animationSlideUp(target, duration, parent_or_link);
    }
  }



  window.app = {



    // Listener for single animation

    inviewAnimation: (e) => {
      const inview = new InView(e, (isInView, data) => {
        const e_animation    = e.getAttribute('data-fx'),
              e_offset       = e.getAttribute('data-fx-offset') || '0%',
              e_offset_value = parseFloat(e_offset.replace(/-[^0-9.,]/g, '')),
              e_offset_px    = (data.inViewHeight / 100) * e_offset_value,
              e_delay        = parseFloat(e.getAttribute('data-fx-delay') || '0'),
              e_duration     = parseFloat(e.getAttribute('data-fx-duration') || '600'),
              v_offset       = data.inViewHeight + (~e_offset_px);
      
        const getElementPosition = (element) => {
          const box        = element.getBoundingClientRect(),
                body       = document.body,
                docEl      = document.documentElement,
                scrollTop  = window.pageYOffset || docEl.scrollTop || body.scrollTop,
                scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft,
                clientTop  = docEl.clientTop || body.clientTop || 0,
                clientLeft = docEl.clientLeft || body.clientLeft || 0,
                top        = box.top + scrollTop - clientTop,
                left       = box.left + scrollLeft - clientLeft;
          
          return { top: Math.round(top), left: Math.round(left) };
        }
      
        if (
          !e.classList.contains('fx_start') &&
          !e.classList.contains('fx_progress') &&
          !e.classList.contains('fx_done')
        ) {
          const v_offset = getElementPosition(e),
                v_offset_top = v_offset.top,
                v_offset_top_calc = v_offset_top - data.inViewHeight + e_offset_px;
      
          if (data.windowScrollTop >= v_offset_top_calc) {
            e.style.WebkitAnimationDuration = `${e_duration}ms`;
            e.style.animationDuration = `${e_duration}ms`;
            e.classList.add('fx_start');
      
            setTimeout(() => {
              e.classList.add('fx_progress');
            }, e_delay);
      
            setTimeout(() => {
              e.classList.add('fx_done');
            }, e_delay + e_duration);
          }
        }
      });
    },

    // Disable section animations in design mode

    inviewAnimationAddDoneClass: () => {
      let inview_items = document.querySelectorAll('[data-fx]');
      if (inview_items.length) {
        inview_items.forEach(item => {
          item.classList.add('fx_done');
        });
      }
    },

    // Init animations

    inviewAnimations: () => {
      let inview_items = document.querySelectorAll('[data-fx]');
      if (inview_items.length) {
        if (Shopify.designMode == true) {
          window.app.inviewAnimationAddDoneClass();
          let i = setInterval(window.app.inviewAnimationAddDoneClass, 1000);
        } else {
          inview_items.forEach(item => {
            window.app.inviewAnimation(item);
          });
        }
      }
    },



    scrollDetect: () => {
      let scrolled = window.scrollY || document.documentElement.scrollTop,
          body = document.querySelector('body'),
          scroll_top = document.querySelector('.scroll_top:not(.event_is_set)');

      if (scrolled > 0) {
        body.setAttribute('data-scrolled','true');
      } else {
        body.setAttribute('data-scrolled','false');
      }

      if (scrolled > 100) {
        document.body.setAttribute('data-show-scroll-top', '1');
      } else {
        document.body.setAttribute('data-show-scroll-top', '0');
      }


      window.app.setHeaderHeightCssVar();

      let header_is_sticky = document.querySelector('#header').closest('[data-sticky-type="always"]');

      if (header_is_sticky) {
        let all_header_height = window.app.getCssVar('--all-header-height', true);
       
        if (all_header_height) {
          if (scrolled > (all_header_height + 100)) {
            document.body.setAttribute('data-slim-header', '1');
          } else {
            document.body.setAttribute('data-slim-header', '0');
          }
        }
      }

      if (scroll_top) {
        scroll_top.classList.add('event_is_set');
        scroll_top.addEventListener('click', (e) => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });   
        });
      }

      let collection_actions = document.querySelector('.product-grid__head__actions');
      if (collection_actions) {
        let _height = collection_actions.offsetHeight,
            _offset_top = collection_actions.getBoundingClientRect().top;
        if (_offset_top+_height < 0 ){
          document.body.setAttribute('data-mobile-filter-icon', 1);
        } else {
          document.body.setAttribute('data-mobile-filter-icon', 0);
        }
      }
      body.setAttribute('data-scrolled', scrolled);
    },



    // Function - Accordions
    
    accordions: () => { 
      let acc_title = document.querySelectorAll('.acc__item__title');
      if( acc_title.length) {
        [].forEach.call(acc_title, (e, index) => {
          e.addEventListener('click', (f) => {
            let item = f.target.closest('.acc__item');
                item_content = item.querySelector('.acc__item__content');
            window.animationSlideToggle(item_content, 300, item);
          });
        });
      }
    },



    // Function - tabs

    tabs: () => { 
      const tabsBtn = document.querySelectorAll('[data-tab-btn]'),
            tabsContent = document.querySelectorAll('[data-tab-content]');

      if (tabsBtn.length > 0 && tabsContent.length > 0) {
        [].forEach.call(tabsBtn, (e, index) => {
          const tabGroup = e.getAttribute('data-tab-group'),
                tabBtn = e.getAttribute('data-tab-btn');

          e.addEventListener('click', () => {
            openTab(tabGroup, tabBtn);
          }, true);
        });
      }
    },

    openTab: (tabGroup, tabBtn) => {
      const tabsContent = document.querySelectorAll(`[data-tab-group="${tabGroup}"][data-tab-content]`),
            tabsBtn = document.querySelectorAll(`[data-tab-group="${tabGroup}"][data-tab-btn]`);

      if (tabsContent.length > 0 && tabsBtn.length > 0) {
        [].forEach.call(tabsContent, (e) => {
          e.classList.remove('is_active');
        });
        
        [].forEach.call(tabsBtn, (e) => {
          e.classList.remove('is_active');
        });
      }

      document.querySelector(`[data-tab-group="${tabGroup}"][data-tab-content="${tabBtn}"]`).classList.add('is_active');
      document.querySelector(`[data-tab-group="${tabGroup}"][data-tab-btn="${tabBtn}"]`).classList.add('is_active');
      window.dispatchEvent(new Event("resize"));  
    },



    sectionHeader: () => {

      // Submenu images

      window.submenu_image_zindex = 10;
      let secondary_menu_subcategories = document.querySelectorAll('#header .secondary_menu [data-menu-id]');
      if (secondary_menu_subcategories.length) {
        [].forEach.call(secondary_menu_subcategories, (e) => {

          e.addEventListener('mouseenter', () => {
            let data_menu_id = e.getAttribute('data-menu-id'),
                submenu_image = document.querySelector('#header .secondary_menu.is_active .submenu_image[data-menu-id="'+ data_menu_id +'"]');
            if (submenu_image) {
              if (!submenu_image.classList.contains('loaded')) {
                let data_image = submenu_image.getAttribute('data-image');
                if (data_image.length) {
                  submenu_image.querySelector('.bg').innerHTML = '<img src="'+ data_image +'" alt="">';
                  submenu_image.classList.add('loaded');
                }
              }
              window.submenu_image_zindex++;
              submenu_image.style.zIndex = window.submenu_image_zindex;
              submenu_image.classList.add('is_active');
            }
          });

          e.addEventListener('mouseleave', () => {
            let data_menu_id = e.getAttribute('data-menu-id'),
                submenu_image = document.querySelector('#header .secondary_menu.is_active .submenu_image[data-menu-id="'+ data_menu_id +'"]');
            if (submenu_image) {
              submenu_image.classList.remove('is_active');
              window.submenu_image_zindex = 10;
            }
          });

        });
      }

      // Submenu - equal height

      let secondary_menus = document.querySelectorAll('#header .secondary_menu');
      if (secondary_menus.length) {

        check_sumbenus_height = (item) => {
          if (item.closest('.secondary_menu')) {
            let submenus = item.closest('.secondary_menu').querySelectorAll('.submenu.lvl_1 > .xgrid'),
                submenus_with_images_height = [],
                submenus_without_images_height = [];

            if (submenus.length) {
              submenus.forEach((e)=>{
                let submenu_image = e.querySelector('.submenu_image');
                if (submenu_image) {
                  e.classList.add('have_submenu_images');
                } else {
                  e.classList.add('not_have_submenu_images');
                }
              });
            }

            let submenus_with_images = item.closest('.secondary_menu').querySelectorAll('.submenu.lvl_1 > .xgrid.have_submenu_images'),
                submenus_without_images = item.closest('.secondary_menu').querySelectorAll('.submenu.lvl_1 > .xgrid.not_have_submenu_images');

            if (submenus_with_images.length) {
              submenus_with_images.forEach((e)=>{
                e.style.minHeight = 'auto';
                submenus_with_images_height.push(e.offsetHeight);
              });

              let max = Math.max(...submenus_with_images_height);

              submenus_with_images.forEach((e)=>{
                e.style.minHeight = max+'px';
              });
            }

            if (submenus_without_images.length) {
              submenus_without_images.forEach((e)=>{
                e.style.minHeight = 'auto';
                submenus_without_images_height.push(e.offsetHeight);
              });

              let max = Math.max(...submenus_without_images_height);

              submenus_without_images.forEach((e)=>{
                e.style.minHeight = max+'px';
              });
            }
            
          }
        };

        secondary_menus.forEach((e) => {
          let lvl_0_links = e.querySelectorAll('li.lvl_0');
          if (lvl_0_links.length) {
              lvl_0_links.forEach((f) => {
              f.addEventListener('mouseenter', (g) => {
                check_sumbenus_height(f);
              });
            });
          }
        });
      }

    },



    pMobileMenu: {

      init: () => {
        let open_btns = document.querySelectorAll('[data-action="open--p_mobile_menu"]'),
            close_btns = document.querySelectorAll('[data-action="close--p_mobile_menu"]'),
            toggle_btns = document.querySelectorAll('[data-action="toggle--p_mobile_menu"]'),
            thirdmenu_btns = document.querySelectorAll('[data-third-menu-btn-eq]'),
            back_btn = document.querySelector('.p_mobile_menu .back');
        
        if (open_btns.length) {
          [].forEach.call(open_btns, function(e) {
            e.addEventListener('click', () => {
              window.app.pMobileMenu.open();
            });
          });
        }

        if (close_btns.length) {
          [].forEach.call(close_btns, function(e) {
            e.addEventListener('click', () => {
              window.app.pMobileMenu.close();
            });
          });
        }

        if (toggle_btns.length) {
          [].forEach.call(toggle_btns, function(e) {
            e.addEventListener('click', () => {
              window.app.pMobileMenu.toggle();
            });
          });
        }

        if (thirdmenu_btns.length) {
          [].forEach.call(thirdmenu_btns, function(e) {
            e.addEventListener('click', () => {
              let eq = e.getAttribute('data-third-menu-btn-eq');
              window.app.pMobileMenu.openThirdMenu(eq);
            });
          });
        }

        if (back_btn) {
          back_btn.addEventListener('click', () => {
            window.app.pMobileMenu.closeThirdMenu();
          });
        }
      },

      updateTopOffset: () => {
        const topLayer = document.querySelector('.p_mobile_menu .top_layer');
        if (topLayer) {
          const rect = topLayer.getBoundingClientRect();
          const offset = rect.top;
          document.documentElement.style.setProperty('--mobile-menu-top-offset', `${offset}px`);
        }
      },

      open: () => {
        document.body.setAttribute('data-p-mobile-menu', '1');
        // Calculate offset after menu transition completes
        requestAnimationFrame(() => {
          setTimeout(() => {
            window.app.pMobileMenu.updateTopOffset();
          }, 50);
        });
      },

      close: () => {
        document.body.setAttribute('data-p-mobile-menu', '0');
        window.app.pMobileMenu.closeThirdMenu();
      },

      toggle: () => {
        let current_value = document.body.getAttribute('data-p-mobile-menu');
        if (current_value == '0') {
          window.app.pMobileMenu.open();
        } else {
          window.app.pMobileMenu.close();
        }
      },

      openThirdMenu: (eq) => {
        document.body.setAttribute('data-third-mobile-menu', eq);
        
        // Remove active class
        let third_menus = document.querySelectorAll('[data-third-menu-content-eq]');
        if (third_menus.length) {
          [].forEach.call(third_menus, function(e) {
            e.classList.remove('is_active');
          });
        }

        // Scroll to top
        let box = document.querySelector('.p_mobile_menu .box');
        if (box) {
          box.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }

        // Add active class to selected item 
        let third_menu = document.querySelector('[data-third-menu-content-eq="'+ eq +'"]');
        if (third_menu) {
          third_menu.classList.add('is_active');
        }

      },

      closeThirdMenu: () => {
        let third_menus = document.querySelectorAll('[data-third-menu-content-eq]');

        if (third_menus.length) {
          let previousLevel   = document.querySelector('.third_menu.is_active');          

          [].forEach.call(third_menus, function(e) {
            e.classList.remove('is_active');
          });

          if ( previousLevel && previousLevel.getAttribute('data-previous-menu-content-eq') ) {
            let menu_content_eq = previousLevel.getAttribute('data-previous-menu-content-eq');
            window.app.pMobileMenu.openThirdMenu(menu_content_eq);
            document.body.setAttribute('data-third-mobile-menu', menu_content_eq);
            return
          } 

        }

        document.body.setAttribute('data-third-mobile-menu', '0');

      }

    },

    pSearch: {

      init: () => {
        this.open_btns = document.querySelectorAll('.js-search-open');
        this.close_btns = document.querySelectorAll('.js-search-close');
            // toggle_btns = document.querySelectorAll('[data-action="toggle--p_search"]'),
        this.container = document.querySelector('.js-search-container');
        this.overlay = document.querySelector('.js-search-overlay');
        this.input = document.querySelector('.js-search-input');
        
        if (this.open_btns.length) {
          [].forEach.call(open_btns, function(e) {
            e.addEventListener('click', () => {
              window.app.pMobileMenu.close();
              window.app.pSearch.open();
            });
          });
        }

        if (this.close_btns.length) {
          [].forEach.call(close_btns, function(e) {
            e.addEventListener('click', (e) => {
              e.preventDefault();
              window.app.pSearch.close();
            });
          });
        }

        if (this.overlay) {
          this.overlay.addEventListener('click', () => {
            window.app.pSearch.close();
          });
        }

        if (input) {
          // input.addEventListener('keyup', (e) => {
            // if (window.p_search_timeout) {
            //   clearTimeout(window.p_search_timeout);
            // }
            // window.p_search_timeout = setTimeout(()=>{
              // window.app.pSearch.search(e.target.value);
              // document.querySelector('.p_search').setAttribute('data-suggestions', 1);
            // }, 400);
          // });

          // input.addEventListener('change', (e) => {
          //   if (window.p_search_timeout) {
          //     clearTimeout(window.p_search_timeout);
          //   }
          //   window.p_search_timeout = setTimeout(()=>{
          //     window.app.pSearch.search(e.target.value);
          //     document.querySelector('.p_search').setAttribute('data-suggestions', 1);
          //   }, 400);
          // });

          // input.addEventListener('paste', (e) => {
          //   if (window.p_search_timeout) {
          //     clearTimeout(window.p_search_timeout);
          //   }
          //   window.app.pSearch.search(e.target.value);
          //   document.querySelector('.p_search').setAttribute('data-suggestions', 1);
          // });

          // input.addEventListener('blur', (e) => {
          //   if (window.p_search_timeout) {
          //     clearTimeout(window.p_search_timeout);
          //   }
          // });
        }


        // window.desktop_results_interval = setInterval(()=>{
        //   const desktop_results = document.querySelector('#rapid-search-results');
        //   if ( desktop_results ) {
        //     clearInterval(window.desktop_results_interval);
        //     const results = document.querySelector('#rapid-search-results');
        //     if ( results ) {

        //       function generate_images() {
        //         let product_images = document.querySelectorAll('#rapid-search-results .rps_predictive_product_image');
        //         if (product_images.length) {

        //           product_images.forEach((e)=>{
        //             let image = e.querySelector('img');
        //             if (!image) {
        //               let src = e.style.backgroundImage;
        //               if (src) {
        //                 src = src.split('url("')[1].split('")')[0].replace('120x120', '426x568');
        //                 e.innerHTML += `<img class="rps_predictive_product_image_new" src="${src}" alt="">`;
        //               }
        //             }
        //           });
        //         }
        //       }

        //       generate_images();

        //       const config = { attributes: false, childList: true, subtree: true };
        //       const callback = (mutationList, observer) => {
        //         for (const mutation of mutationList) {
        //           if (mutation.type === "childList") {
        //             //console.log("A child node has been added or removed.");
        //             generate_images();                    
        //           } 
        //           // else if (mutation.type === "attributes") {
        //           //   console.log(`The ${mutation.attributeName} attribute was modified.`);
        //           // }
        //         }
        //       };
              
        //       const observer = new MutationObserver(callback);
        //       observer.observe(results, config);
        //     }
        //   }
          
        // }, 2000);


      },

      open: () => {
        if (this.container) {
          this.container.classList.add('-opened');
          document.body.classList.add('predictive-search-is-open');
        }
        
        // let rps_button = document.querySelector('#rps_sticky_widget');
        // if (rps_button) {
        //   rps_button.click();
        // }
        // document.body.setAttribute('data-p-search', '1');
        
        if (this.input) {
          this.input.focus({
            preventScroll: true
          });
        }
      },

      close: () => {
        if (this.container) {
          this.container.classList.remove('-opened');
          document.body.classList.remove('predictive-search-is-open');
          }
        // document.body.setAttribute('data-p-search', '0');
      },

      toggle: () => {
        // let current_value = document.body.getAttribute('data-p-search');
        // if (current_value == '0') {
        //   window.app.pSearch.open();
        // } else {
        //   window.app.pSearch.close();
        // }
      },

      search: (text) => {
        // if (text.length > 2) {
        //   document.querySelector('.p_search').classList.add('is_loading');

        //   fetch(`/search?q=${text}&sections=p_search_results`)
        //   .then((response) => response.json())
        //   .then((data) => {
        //     if (window.p_search_loading_timeout) {
        //       clearTimeout(window.p_search_loading_timeout);
        //     }

        //     let container = document.querySelector('.p_search .xcell--content');
        //     if (container) {
        //       container.innerHTML = data.p_search_results;
        //       document.querySelector('.p_search').classList.remove('is_loading');
        //     }
        //   });        
        // }
      }

    },

    sectionFooter: () => {

      var footer_boxes_title = document.querySelectorAll('#footer .xgrid--top .box__title');
      if (footer_boxes_title) {
        [].forEach.call(footer_boxes_title, function(e) {
          e.addEventListener('click', function(f) {
            if (window.innerWidth <1000) {
              if (this.closest('.box').classList.contains('is_active')) {
                window.animationSlideUp(this.closest('.box').querySelector('.box__content'), 300);
                this.closest('.box').classList.remove('is_active');
              } else {
                window.animationSlideDown(this.closest('.box').querySelector('.box__content'), 300);
                this.closest('.box').classList.add('is_active');
              }
            }
          });
        });
      }

    },


    sectionBreadcrumbs: {

      init: () => {
        
        let detect = document.querySelector('.sn_breadcrumbs.detect');
        if (detect) {
          let root_collection = localStorage.getItem('root_collection');
          if (root_collection) {
            let menu_item = document.querySelector('#header .primary_menu [data-primary-menu-eq="'+root_collection+'"]');
            if (menu_item) {
              let title = menu_item.querySelector('span').innerHTML,
                  url = menu_item.querySelector('a').getAttribute('href');
              
              detect.querySelector('[data-lvl="0"] a').innerHTML = title;
              detect.querySelector('[data-lvl="0"] a').setAttribute('href', url);
              detect.classList.remove('detect');
            }

          } else {
            detect.classList.remove('detect');
          }
        }
      
      }

    },


    sectionInstafeed: {

      init: () => {

        let instafeed = document.querySelectorAll('#insta-feed');
        if (instafeed.length) {
          instafeed.forEach((e) => {
            let instagram_link = document.querySelector('#footer .instagram a'),
                url = '#';

            if (instagram_link) {
              url = instagram_link.getAttribute('href');
            }

            e.closest('.shopify-section').classList.add('insta-feed-section');
            const seeMoreText = (window.instagramStrings && window.instagramStrings.seeMore) ? window.instagramStrings.seeMore : 'See more';
            e.closest('.page-width').innerHTML +=  '<a href="'+url+'" target="_blank" class="insta-feed-btn"><span class="insta-feed-btn__inner"><span class="insta-feed-btn__icon"></span><span class="insta-feed-btn__label">'+seeMoreText+'</span></span></a>';
          });
        }
      
      }

    },


    collectionHistory: {


      getLs: () => {
        if ( localStorage.getItem('collection_history') != null ) {
          return localStorage.getItem('collection_history');
        } else {
          return '';
        }
      },


      setLs: (stringValue) => {
        localStorage.setItem('collection_history', stringValue.replace(/^\s+|\s+$/gm,'').replace(/(\r\n|\n|\r)/gm,''));
      },


      getData: () => {
        let data = false;

        if ( window.app.collectionHistory.getLs() != '' ) {
          data = [];
          let history_array = localStorage.getItem('collection_history').split('|||');
                    
          history_array.forEach((e, index)=> {
            data[index] = {
              tpl: e.split('||')[0],
              url: e.split('||')[1],
              scrolled: e.split('||')[2],
              html: e.split('||')[3],
              timestamp: e.split('||')[4]
            };  
          });
        }

        return data;
      },


      dataToString : (data) => {
        let result = '';

        data.forEach((e, index) => {
          if (index != 0 ){
            result = result + '|||';  
          };
          // result = result + e.tpl + '||' + e.url + '||' + e.scrolled + '||' + e.html;
          result = e.tpl + '||' + e.url + '||' + e.scrolled + '||' + e.html + '||' + e.timestamp;
        });

        return result;
      },


      stringToData: (string) => {
        let data = [],
            history_array = string.split('|||');
                    
        history_array.forEach((e, index)=> {
          data[index] = {
            tpl: e.split('||')[0],
            url: e.split('||')[1],
            scrolled: e.split('||')[2],
            html: e.split('||')[3],
            timestamp: e.split('||')[4]
          };
        });

        return data;
      },

      
      setData: () => {
        let old_data = window.app.collectionHistory.getData(),
            new_data = [];
            new_data_obj_exist = false;

        if ( old_data != false ) {

          if (old_data.length > 2) {
            old_data = old_data.slice(-2);
          }

          new_data = old_data;
          new_data.forEach((e, index) => {
            if (e.url == window.location.href) {
            
              let _tpl = document.querySelector('body').getAttribute('data-tpl'),
                  _url = window.location.href, 
                  _scrolled = document.querySelector('body').getAttribute('data-scrolled'),
                  _html = document.querySelector('.main-collection .product-grid').innerHTML,
                  _timestamp = Date.now();

              new_data[index] = {
                tpl: _tpl,
                url: _url,
                scrolled: _scrolled,
                html: _html,
                timestamp: _timestamp
              };

              new_data_obj_exist = true;
            }
          });

          if ( new_data_obj_exist == false ) {
            let _tpl = document.querySelector('body').getAttribute('data-tpl'),
                _url = window.location.href, 
                _scrolled = document.querySelector('body').getAttribute('data-scrolled'),
                _html = document.querySelector('.main-collection .product-grid').innerHTML,
                _timestamp = Date.now();
                
            let new_data_obj = {
              tpl: _tpl,
              url: _url,
              scrolled: _scrolled,
              html: _html,
              timestamp: _timestamp
            };

            new_data = new_data.slice(-1);
            new_data.push(new_data_obj);
          }

          return new_data;

        } else {

          let _tpl = document.querySelector('body').getAttribute('data-tpl'),
              _url = window.location.href, 
              _scrolled = document.querySelector('body').getAttribute('data-scrolled'),
              _html = document.querySelector('.main-collection .product-grid').innerHTML,
              _timestamp = Date.now();

          new_data = [{
            tpl: _tpl,
            url: _url,
            scrolled: _scrolled,
            html: _html,
            timestamp: _timestamp
          }];

          return new_data;

        }
      },


      saveData: () => {
        window.app.collectionHistory.setLs(window.app.collectionHistory.dataToString(window.app.collectionHistory.setData()));
      },


      scrollPage: (y) => {
        window.scrollTo(0, y);
      },


      detect: () => {
        setBodyVisible = () => {
          let collection = document.querySelector('[data-tpl="collection"]');
          if (collection){
            collection.classList.add('is_visible');
          }
        };

        if (document.querySelector('[data-tpl="collection"] .pagination-infinite__progress')) {
          if ( window.location.href.indexOf('?') !== -1 ) {
            localStorage.removeItem('collection_history');
            setBodyVisible();
          }

          if ( window.app.collectionHistory.getLs() != '' ) {
            let history_data = window.app.collectionHistory.stringToData(window.app.collectionHistory.getLs()),
                pagination = document.querySelector('.product-grid__pagination');

            if ( history_data.length ){
              let current_timestamp = parseFloat(Date.now()),
                  prev_timestamp = parseFloat(history_data[0].timestamp),
                  max_diff_in_ms = 1000*60*60; // 1h

              if ((prev_timestamp + max_diff_in_ms) < current_timestamp) {
                localStorage.removeItem('collection_history');
                setBodyVisible();
              } else {
                if ( history_data[0].tpl == 'collection' && history_data[0].url == window.location.href) {
                  if ( pagination ) {
                    document.querySelector('.product-grid__pagination').loadMore(0, parseFloat(history_data[0].scrolled));
                  } else {
                    setBodyVisible();
                  }
                } else if ( history_data[0].tpl == 'collection' && history_data[0].url != window.location.href) {
                  setBodyVisible();
                } else {
                  setBodyVisible();
                }
              }
            } else {
              setBodyVisible();
            }
          } else {
            setBodyVisible();
          }

          window.addEventListener('scroll', () => {
            window.app.collectionHistory.saveData();
          });
        } else {
          setBodyVisible();
        }
      }


    },



    truncateHTML: (content, maxLength = 200, append = '…') => {

      let container = document.createElement('div'),
          limitReached = false;
          counted = 0;
      
      container.innerHTML = content;

      let nodeHandler = node => {
          if ( limitReached ) {
            node.remove();
            return;
          }

          let childNodes = Array.from( node.childNodes );
          if ( childNodes.length ) {
            childNodes.forEach( childNode => nodeHandler( childNode ) );
          } else {
            counted += node.textContent.length;
            if ( counted >= maxLength ) {
              limitReached = true;
              if ( counted > maxLength ) {
                node.textContent = node.textContent.slice( 0, -(counted - maxLength) )
              }

              node.textContent += append;
            }
          }
      };

      nodeHandler( container );
      return container.innerHTML;
      
    },



    pageCollection:  {

      init: () => {
        
        let description_to_truncate_containers = document.querySelectorAll('.collection-hero__description--truncate');
        
        if ( description_to_truncate_containers.length ) {
          description_to_truncate_containers.forEach((e) => {
            let description_to_truncate = e.querySelector('.read-more__text--full'),
                description_truncated = e.querySelector('.read-more__text--truncated'),
                description_read_more_btn = e.querySelector('.read-more__btn');

            if ( description_to_truncate && description_truncated ) {
              let max_chars = e.getAttribute('data-truncate-chars'), 
                  result = window.app.truncateHTML(description_to_truncate.innerHTML, parseFloat(max_chars));
              
              description_truncated.innerHTML = result;

              if ( description_to_truncate.innerHTML != description_truncated.innerHTML ) {
                e.classList.add('show-read-more-btn');
                
                description_read_more_btn.addEventListener('click', () => {
                  if ( e.classList.contains('show-full-text') ) {
                    e.classList.add('show-read-more-btn');
                    e.classList.remove('show-full-text');
                  } else {
                    e.classList.remove('show-read-more-btn');
                    e.classList.add('show-full-text');
                  }
                });
              }
            }
          });
        }

      }
    },



    pageProduct:  {

      init: () => {
        
        let description_to_truncate_containers = document.querySelectorAll('.tabs__content__item--description--truncate');
        
        if ( description_to_truncate_containers.length ) {
          description_to_truncate_containers.forEach((e) => {
            let description_to_truncate = e.querySelector('.read-more__text--full'),
                description_truncated = e.querySelector('.read-more__text--truncated'),
                description_read_more_btn = e.querySelector('.read-more__btn');

            if ( description_to_truncate && description_truncated ) {
              let max_chars = e.getAttribute('data-truncate-chars'), 
                  result = window.app.truncateHTML(description_to_truncate.innerHTML, parseFloat(max_chars));
              
              description_truncated.innerHTML = result;

              if ( description_to_truncate.innerHTML != description_truncated.innerHTML ) {
                e.classList.add('show-read-more-btn');
                
                description_read_more_btn.addEventListener('click', () => {
                  e.classList.remove('show-read-more-btn');
                  e.classList.add('show-full-text');
                });
              }
            }
          });
        }

      }
    },



    setCssVar: (variable ,value) => {

      const r = document.querySelector(':root');
      r.style.setProperty(variable, value);
    
    },



    getCssVar: (variable, only_value = false) => {
 
      const r = document.querySelector(':root'),
            r_style = getComputedStyle(r);

        if (only_value == true) {
          return parseFloat(r_style.getPropertyValue(variable));
        } else {
          return r_style.getPropertyValue(variable);
        }
 
    },



    setHeaderHeightCssVar: () => {

      const announcement_bar = document.querySelector('.announcement-bar-section'),
            header = document.querySelector('body > .section-header');

      let h = 0;

      if (announcement_bar) {
        let _h = announcement_bar.offsetHeight;
        h += _h; 
        window.app.setCssVar('--announcement-bar-height', _h+'px');
      }

      if (header) {
        let _h = header.offsetHeight;
        h += _h; 
        window.app.setCssVar('--header-height', _h+'px');
      }

      window.app.setCssVar('--all-header-height', h+'px');

    },

    logoConditionalUrl: () => {

      const logoElement = document.querySelector('.logo'),
            logoMenuId = logoElement.getAttribute('data-logo-link-menu-id');

      if (logoMenuId != 'none') {
        logoElement.addEventListener('click', e => {
          localStorage.setItem('root_collection', logoMenuId);
          
          /*
          let active_items = document.querySelectorAll('#header [data-primary-menu-eq]');
          if (active_items.length) {
            active_items.forEach((e) => {
              e.classList.remove('is_active');
            });
          }

          let current_item = document.querySelector('#header [data-primary-menu-eq="'+logoMenuId+'"]');
          if (current_item) {
            current_item.classList.add('is_active');
          }

          let secondary_menus = document.querySelectorAll('#header [data-secondary-menu-eq]');
          if (secondary_menus.length) {
            secondary_menus.forEach((e) => {
              e.classList.remove('is_active');
            });
          }

          let current_secondary_menu = document.querySelector('#header [data-secondary-menu-eq="'+logoMenuId+'"]');
          if (current_secondary_menu) {
            current_secondary_menu.classList.add('is_active');
          }
          */
        });
      }

    },

    onResize: () => {
      
      window.app.setHeaderHeightCssVar();
      window.app.pMobileMenu.updateTopOffset();
      
    },



    onScroll: () => {
 
      window.app.scrollDetect();

      if (window.scrollDtetctTimeout) {
        clearTimeout(window.scrollDtetctTimeout);
      }

      window.scrollDtetctTimeout = setTimeout(()=>{
        window.app.scrollDetect();
      }, 500);
 
    },



    shopifyChat: {

      init: () => {

        window.shopifyChatInterval = setInterval(() => {
          let chat = document.querySelector('#shopify-chat');
          if (chat) {
            window.app.shopifyChat.check();
            chat.addEventListener('click', () => {
              window.app.shopifyChat.check();
            });
            chat.classList.add('event_is_set');
          }
        }, 300);
        
      },

      check: () => {

        let chat = document.querySelector('#shopify-chat'),
            inbox = chat.querySelector('inbox-online-store-chat'),
            inbox_title = inbox.shadowRoot.querySelector('.chat-title'),
            inbox_button = inbox.shadowRoot.querySelector('button'),
            inbox_close = inbox.shadowRoot.querySelector('.chat-header__close_button_mobile');
        if (chat && inbox_title && inbox_button) {
          inbox_title.style.display = "none";
          inbox_button.style.paddingRight = '3px';
          inbox_button.style.background = '#35383a';
        }

        if (inbox_close) {
          inbox_close.style.width = '31px';
          inbox_close.style.height = '31px';
        }

        setTimeout(()=>{
          chat.classList.add('is_active');
        }, 300);

      }

    },



    init: () => {

      window.app.collectionHistory.detect();
      window.app.logoConditionalUrl();
      window.app.scrollDetect();
      window.app.inviewAnimations();
      window.app.accordions();
      window.app.tabs();
      window.app.pMobileMenu.init();
      window.app.pSearch.init();

      window.app.sectionHeader();
      window.app.sectionFooter();
      window.app.sectionBreadcrumbs.init();
      window.app.sectionInstafeed.init();
      window.app.pageCollection.init();
      window.app.pageProduct.init();
      window.app.shopifyChat.init();

      document.querySelector('wishlist-counter').update();
      document.querySelector('wishlist-counter-mobile').update();

    },
    


  };
})(window, window.document);



document.addEventListener('DOMContentLoaded', () => {
    
  window.app.init();
  window.addEventListener('resize', window.app.onResize);
  window.addEventListener('scroll', window.app.onScroll);
    
  window.dispatchEvent(new Event('resize'));
  window.dispatchEvent(new Event('scroll'));

});



class CartCounter extends HTMLElement {
  constructor() {
    super();
  }

  set(number) {
    let value = parseFloat(number)
    if (value > 0) {
      this.innerHTML = number;
    } else {
      this.clear();
    }
  }

  plus(number) {
    let value = this.innerHTML == '' ? number : parseFloat(this.innerHTML) + number;
    this.innerHTML = value;
  }

  minus(number) {
    let value = this.innerHTML == '' ? 0 : parseFloat(this.innerHTML) - number;
    if (value > 0) {
      this.innerHTML = value;
    } else {
      this.innerHTML = '';
    }
  }

  clear() {
    this.innerHTML = '';
  }

  update() {
    fetch(`/cart.js`)
    .then((response) => response.json())
    .then((data) => {
      this.set(data.item_count);
    });
  }
}

customElements.define('cart-counter', class extends CartCounter {});
customElements.define('cart-counter-mobile', class extends CartCounter {});



class WishlistCounter extends HTMLElement {
  constructor() {
    super();
  }

  set(number) {
    let value = parseFloat(number)
    if (value > 0) {
      this.innerHTML = number;
    } else {
      this.clear();
    }
  }

  plus(number) {
    let value = this.innerHTML == '' ? number : parseFloat(this.innerHTML) + number;
    this.innerHTML = value;
  }

  minus(number) {
    let value = this.innerHTML == '' ? 0 : parseFloat(this.innerHTML) - number;
    if (value > 0) {
      this.innerHTML = value;
    } else {
      this.innerHTML = '';
    }
  }

  clear() {
    this.innerHTML = '';
  }

  update() {
    let value = 0;
    if (localStorage.getItem('iWishCnt') != null ) {
      value = localStorage.getItem('iWishCnt');
    }

    if (value > 0) {
      document.body.setAttribute('data-wishlist-is-empty', '0');
    } else {
      document.body.setAttribute('data-wishlist-is-empty', '1');
    }

    this.set(value);
  }
}

customElements.define('wishlist-counter', class extends WishlistCounter { });
customElements.define('wishlist-counter-mobile', class extends WishlistCounter { });
